import { ApiBase } from '@/api/methods/ApiBase'
import { ApiResponseNotifications } from '@/api/responses/notifications'
import { ApiResponseCreateNotification } from '@/api/responses/manage/notifications'

export namespace NotificationsApi {
  /**
   * お知らせ一覧検索
   *
   * @param year 対象年
   * @param month 対象月
   * @param pageNumber ページ番号
   * @param count 取得件数
   * @param options オプション項目
   * @param options.type お知らせ種別
   * @param options.orderReverse ソート逆順フラグ
   *
   * @returns お知らせ情報リスト
   */
  export async function searchNotifications(
    year: number,
    month: number,
    pageNumber: number,
    count: number,
    options?: {
      /** お知らせ種別 */
      type?: string
      /** ソート逆順フラグ */
      orderReverse: boolean
    }
  ): Promise<ApiResponseNotifications> {
    const params = {
      year: year,
      month: month,
      pageNumber: pageNumber,
      count: count,
    }

    // 任意パラメータを設定
    if (options) {
      // お知らせタイプ
      if (options.type) {
        Object.assign(params, { type: options.type })
      }
      // ソート逆順フラグ(falseの場合も設定不要)
      if (options.orderReverse) {
        Object.assign(params, { orderReverse: options.orderReverse })
      }
    }

    return await ApiBase.get('/manage/notifications', params)
  }

  /**
   * お知らせ登録
   *
   * @param title タイトル
   * @param message 本文
   * @param startAt 開始日(UNIX秒)
   * @param endAt 終了日(UNIX秒)
   *
   * @returns 登録情報
   */
  export async function createNotification(
    title: string,
    message: string,
    startAt: number,
    endAt: number
  ): Promise<ApiResponseCreateNotification> {
    const params = {
      title: title,
      message: message,
      startAt: startAt,
      endAt: endAt,
    }
    return await ApiBase.post('/manage/notifications', params)
  }

  /**
   * お知らせ更新
   *
   * @param id お知らせID
   * @param title タイトル
   * @param message 本文
   * @param startAt 開始日(UNIX秒)
   * @param endAt 終了日(UNIX秒)
   * @param lastUpdatedAt 最終更新時刻(UNIX秒)
   */
  export async function updateNotification(
    id: number,
    title: string,
    message: string,
    startAt: number,
    endAt: number,
    lastUpdatedAt: number
  ): Promise<void> {
    const params = {
      title: title,
      message: message,
      startAt: startAt,
      endAt: endAt,
      lastUpdatedAt: lastUpdatedAt,
    }
    await ApiBase.post(`/manage/notifications/${id}`, params)
  }

  /**
   * お知らせ削除
   *
   * @param id お知らせID
   */
  export async function deleteNotification(id: number): Promise<void> {
    await ApiBase.post(`/manage/notifications/${id}/delete`)
  }
}
